import { CRUDEntity } from "../abstracts/CRUDEntity";

export class Organisation extends CRUDEntity {

    constructor(id=null, addParams=null) {
        super();
        this.entityClass = 'organisation';
        this.urlRoot = '/admin/business-reports';
        this.sectionRootUrl = '';
        this.id = id;
        this.addParams=addParams
    }
}